import React, { useEffect, useState } from 'react';
import {
  Box, Typography, List, ListItem, ListItemText, Divider, TextField, Button, Grid, CircularProgress, Paper, ToggleButton, ToggleButtonGroup
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import api, { API_BASE_URL } from "../../utils/api";



const EmailTemplateManager = () => {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [form, setForm] = useState({ subject: '', body: '' });
  const [viewMode, setViewMode] = useState('edit'); // 'edit' | 'preview'

  useEffect(() => {
    api.get(`/email-templates`)
      .then(res => {
        setTemplates(res.data);
        setIsLoading(false);
      })
      .catch(err => {
        console.error('Error loading templates', err);
        setIsLoading(false);
      });
  }, []);
  

  const handleSelect = (template) => {
    setSelected(template);
    setForm({ subject: template.subject, body: template.body });
    setViewMode('edit'); // reset to edit view when switching template
  };

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSave = () => {
    if (!selected) return;

    api.put(`/email-templates/${selected.id}`, {
      subject: form.subject,
      body: form.body,
      name: selected.name,
      module: selected.module,
      is_active: selected.is_active
    })
      .then(() => {
        alert('✅ Template saved successfully!');
      })
      .catch(err => {
        console.error('❌ Failed to save template', err);
        alert('❌ Failed to save template');
      });
    
  };

  const handleViewToggle = (_, newValue) => {
    if (newValue !== null) setViewMode(newValue);
  };

  if (isLoading) {
    return <Box textAlign="center" mt={5}><CircularProgress /></Box>;
  }

  return (
    <Grid container spacing={2} padding={3}>
      {/* Sidebar list */}
      <Grid item xs={12} md={4}>
        <Typography variant="h6" gutterBottom>
          📂 Templates
        </Typography>
        <Paper elevation={2}>
          <List>
            {templates.map((tpl) => (
              <div key={tpl.id}>
                <ListItem button selected={selected?.id === tpl.id} onClick={() => handleSelect(tpl)}>
                  <EmailIcon fontSize="small" style={{ marginRight: 8 }} />
                  <ListItemText primary={tpl.name} secondary={tpl.module} />
                </ListItem>
                <Divider />
              </div>
            ))}
          </List>
        </Paper>
      </Grid>

      {/* Editor + Preview Toggle */}
      <Grid item xs={12} md={8}>
        {selected ? (
          <>
            <Typography variant="h6" gutterBottom>
              ✏️ Edit Template: {selected.name}
            </Typography>

            <TextField
              fullWidth
              label="Subject"
              name="subject"
              value={form.subject}
              onChange={handleChange}
              margin="normal"
            />

            {/* Toggle Buttons */}
            <Box mt={2} mb={2}>
              <ToggleButtonGroup
                value={viewMode}
                exclusive
                onChange={handleViewToggle}
                aria-label="View Mode"
              >
                <ToggleButton value="edit" aria-label="Edit">
                  <EditIcon sx={{ mr: 1 }} /> Edit
                </ToggleButton>
                <ToggleButton value="preview" aria-label="Preview">
                  <VisibilityIcon sx={{ mr: 1 }} /> Preview
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>

            {/* Conditional View */}
            {viewMode === 'edit' ? (
              <TextField
                fullWidth
                label="Body (HTML)"
                name="body"
                value={form.body}
                onChange={handleChange}
                margin="normal"
                multiline
                minRows={12}
              />
            ) : (
              <Paper variant="outlined" sx={{ padding: 2, backgroundColor: '#fff', minHeight: '300px' }}>
                <div dangerouslySetInnerHTML={{ __html: form.body }} />
              </Paper>
            )}

            {/* Save Button */}
            <Box mt={2}>
              <Button variant="contained" onClick={handleSave}>💾 Save Template</Button>
            </Box>
          </>
        ) : (
          <Typography>Select a template from the left to view and edit.</Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default EmailTemplateManager;
